import { selectNiumForexReducer, selectUserStatusReducer } from '@Redux/selectors';
import { useSelector } from 'react-redux';
import { NiumForexReducer, UserStatusReducer } from '../../../../../store.type';
import { sideNavMenuItems } from '../utils';
import { NavItem } from '../SideNav.types';
import { APPROVED, AUTHORIZATIONS, CORPORATE, INDIVIDUAL, NIUM_FOREX_URL } from '@Utils/constants';
import { isKYCSplitFlow } from '@Utils/library';
import { useLocation } from 'react-router';
import { NF_ALLOWED_ROUTES, NF_SCREENS } from '../../../../nium-forex/root/screenConstants';
import { isUniformReferralCountry } from '../../../../referrals-instapoints/utils';

/**
 *
 * custom hook to render nav item conditionally
 * Returns the list of side nav items visible to the current user.
 * Filters out items that require individual account type (e.g.instapoints, refer-earn)
 * when the user is not an individual account holder.
 *
 *
 */

export const useNavItems = () => {
  const {
    account_type: userAccountType,
    status: userStatus,
    country_code: countryCode
  } = useSelector(selectUserStatusReducer) as UserStatusReducer;

  const { isNiumForexUser = false, currentScreen: niumForexCurrentScreen } = useSelector(
    selectNiumForexReducer
  ) as NiumForexReducer;

  const { pathname } = useLocation();

  function isAuthorized(url: string) {
    const splitKYC = isKYCSplitFlow(countryCode, userStatus, true, userAccountType);
    const isPreDashboard =
      pathname === NIUM_FOREX_URL && niumForexCurrentScreen === NF_SCREENS.mobile_verification;
    if (isNiumForexUser) {
      if (isPreDashboard) return false;
      return NF_ALLOWED_ROUTES.includes(url);
    }
    let paths = AUTHORIZATIONS[splitKYC ? APPROVED : userStatus];
    return paths && paths.find((text) => text === url);
  }

  const isIndividual = userAccountType === INDIVIDUAL;
  const isCorporate = userAccountType === CORPORATE;

  return sideNavMenuItems.filter((item: NavItem) => {
    switch (item.key) {
      case 'instapoints':
        return isIndividual && isAuthorized(item.route) && !isUniformReferralCountry(countryCode);
      case 'rewards':
        return isIndividual && isAuthorized(item.route) && isUniformReferralCountry(countryCode);

      case 'refer-earn':
      case 'help-centre':
        return isIndividual && isAuthorized(item.route);
      case 'help-centre-corporate':
        return isCorporate;
      default:
        return isAuthorized(item.route);
    }
  });
};
